// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"318":"7d98720b","680":"16e6df6d"}[chunkId] + ".css";
};